import { parsePhoneNumber } from "libphonenumber-js";
import PropTypes from "prop-types";
import { PhoneInput } from "./phone-input";
import { getIn } from "formik";
import { FormControl, FormLabel } from "@mui/material";

export function RHFPhoneInput({ 
  name, 
  countryCodeName = 'countryCode',
  formik, 
  helperText,
  disabled,
  showDialCode = true,
  defaultCountryCode = 'IN',
  ...other 
}) {
  
  const countryCode = formik.values[countryCodeName] || defaultCountryCode;
  const mobileNumber = formik.values[name] || '';
  const fullPhoneNumber = countryCode && mobileNumber ? `${countryCode}${mobileNumber}` : '';

  const fieldError = getIn(formik.errors, name);
  const isTouched = getIn(formik.touched, name);
  const hasError = Boolean(isTouched && fieldError);

  const handlePhoneChange = (value) => {
    if (!value) {
      formik.setFieldValue(countryCodeName, '');
      formik.setFieldValue(name, '');
      return;
    }

    try {
      const parsedNumber = parsePhoneNumber(value);
      if (parsedNumber) {
        if (formik.values[countryCodeName] !== `+${parsedNumber.countryCallingCode}`) {
          formik.setFieldValue(countryCodeName, `+${parsedNumber.countryCallingCode}`);
        }
        if (formik.values[name] !== parsedNumber.nationalNumber) {
          formik.setFieldValue(name, parsedNumber.nationalNumber);
        }
      } else {
        formik.setFieldValue(name, value);
      }
    } catch (error) {
      console.warn('Phone number parsing error:', error);
      formik.setFieldValue(name, value);
    }
  };

  const handleBlur = () => {
    formik.setFieldTouched(name, true);
    formik.setFieldTouched(countryCodeName, true);
  };

  return (
        <FormControl fullWidth>
      <FormLabel
        className="form-label"
        htmlFor={name}
        sx={{
          color: "#1C252E",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "22px",
          mb: "6px",
        }}
      >
        {other.label}
        {other.required && <span className="asteriskColor"> *</span>}
      </FormLabel>
    <PhoneInput
      value={fullPhoneNumber}
      onChange={handlePhoneChange}
      onBlur={handleBlur}
      error={hasError}
      helperText={hasError && typeof fieldError === 'string' ? fieldError : helperText}
      showDialCode={showDialCode}
      fullWidth
      required= {other.required}
      disabled={disabled}
      {...other}
    />
    </FormControl>
  );
}



RHFPhoneInput.propTypes = {
  countryCodeName: PropTypes.any,
  defaultCountryCode: PropTypes.any,
  disabled: PropTypes.bool,
  formik: PropTypes.object,
  helperText: PropTypes.any,
  name: PropTypes.any,
  showDialCode: PropTypes.bool,
};
